<template>
  <div>
    <v-btn x-small @click="deselectAll">Deselect all</v-btn>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="metadata"
      item-key="idx"
      class="elevation-1"
      show-select
      single-expand
      show-expand
      :expanded.sync="expanded"
      dense
    >
      <template v-slot:[`header.data-table-select`]="{}"> </template>
      <template v-slot:[`item.map`]="{ item }">
        <v-simple-checkbox
          v-if="!item.disableMap"
          v-model="item.map"
          :disabled="item.disableTrack"
        ></v-simple-checkbox>
      </template>
      <template v-slot:[`item.track`]="{ item }">
        <v-simple-checkbox
          v-if="!item.disableTrack"
          v-model="item.track"
          :disabled="item.disableMap"
        ></v-simple-checkbox>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div class="row sp-details">
            <div class="col-6 text-left pa-1 pt-3">
              <b>Category</b>
            </div>
            <div class="col-3 text-left pa-1 pt-3">
              <b>Color</b>
            </div>
            <div v-show="showColorPicker" class="col-4 text-left">
              <b>Color Picker</b>
            </div>
            <div class="col-3 text-left pa-1 pt-3">
              <b>Opacity</b>
            </div>
          </div>
          <div v-for="(cat, idx) in item.categories" :key="idx" class="row sp-details">
            <div class="col-6 text-left pa-1">
              {{ cat.label }}
            </div>
            <div class="col-3 text-left pa-1">
              <input id="body" v-model="cat.style.fill" type="color" />
            </div>
            <div class="col-3 text-left pa-0 pl-1">
              <v-text-field v-model="cat.style['fill-opacity']" class="pa-0 ma-0"></v-text-field>
            </div>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    metadata: {
      type: Array,
      default: () => [],
    },
    preselected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedProxy: null,
      expanded: [],
      headers: [
        {
          text: 'Label',
          sortable: true,
          align: 'start',
          value: 'label',
        },
        {
          text: 'Map on alignment',
          sortable: false,
          align: 'middle',
          value: 'map',
        },
        {
          text: 'Display as track',
          sortable: false,
          align: 'middle',
          value: 'track',
        },
        { text: 'Categories', value: 'data-table-expand' },
      ],
      showColorPicker: false,
    };
  },
  computed: {
    selected: {
      get: function() {
        return this.selectedProxy == null ? this.preselected : this.selectedProxy;
      },
      set: function(newValue) {
        this.selectedProxy = newValue;
      },
    },
  },
  watch: {
    selected(val) {
      this.$emit('select-metadata', val);
    },
  },
  methods: {
    getStyleButton(cat) {
      return { opacity: cat.style.opacity };
    },
    deselectAll() {
      this.selected = [];
    },
  },
};
</script>

<style></style>
